class ShippingCarrier extends HTMLElement {
    constructor(){
        super();

        const template = `
        <div>
            <select id="carrier">
                <option value="">Select Carrier</option>
                <option value="UPS">UPS</option>
                <option value="FedEx">FedEx</option>
            </select>
            <div class="input-container">
                <input type="text" placeholder="Account number" id="tracking-number">
                <div class="info-logo">
                    <span class="info-icon">i</span>
                    <span class="info-message">Provide UPS or FedEx account number (Optional)</span>
                </div>
            </div>
        </div>
      

        <style>
            /* Style for the container div */
            div {
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 1rem 0;
            }

            /* Style for the select element */
            select {
                padding: 9px;
                font-size: 16px;
                border: 1px solid #ccc;
                margin-right: 10px;
                flex-basis: 35%;
                text-decoration: none;
                border-radius: var(--button-radius);
                border: var(--button-border-width) solid rgb(var(--color-button-border));
                font-family: var(--font-button-family);
            }

            /* Style for the input element */
            input[type="text"] {
                padding: 10px;
                font-size: 16px;
                border: 1px solid #ccc;
                width: 100%;
                text-decoration: none;
                border-radius: var(--button-radius);
                border: var(--button-border-width) solid rgb(var(--color-button-border));
                font-family: var(--font-button-family);
            }

            /* Optional styles for a better visual appearance */
            body {
                background-color: #f0f0f0;
                font-family: Arial, sans-serif;
            }

            h1 {
                text-align: center;
            }

            .input-container {
                position: relative;
                flex-basis: 65%;
            }

            .info-logo {
                position: absolute;
                top: 25%;
                right: 5px;
                transform: translateY(-50%);
                display: inline-block;
                width: 20px;
                height: 20px;
                background-color: #f0f0f0;
                border-radius: 50%;
                text-align: center;
                cursor: pointer;
            }

            .info-icon {
                display: block;
                font-weight: bold;
                line-height: 20px;
                color: #333;
            }

            .info-message {
                display: none;
                position: absolute;
                top: -60px;
                right: 0;
                max-width: 335px;
                min-width: 335px;
                padding: 10px;
                background-color: #f0f0f0;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                text-align: center;
                font-size: 16px;
                line-height: 1.5;
                color: #333;
            }

            .info-logo:hover .info-message {
                display: block;
            }
        </style>
      `;
  
      const shadowRoot = this.attachShadow({ mode : 'open' });
      shadowRoot.innerHTML = template;
    }

    connectedCallback() {
        const carrierInput = this.shadowRoot.getElementById('carrier');
        const trackingNumberInput = this.shadowRoot.getElementById('tracking-number');

        
        const handleChange = debounce(() => {
            const carrier = carrierInput.value;
            const trackingNumber = trackingNumberInput.value;
            const shippingInfo = { carrier, trackingNumber };

            if(carrier != '' && trackingNumber != ''){
                this.dispatchEvent(new CustomEvent('shipping-info-changed', { detail: shippingInfo }));
            }
        }, 500);
      
        carrierInput.addEventListener('input', handleChange);
        trackingNumberInput.addEventListener('input', handleChange);


        this.addEventListener('shipping-info-changed', (event) => {
            const { carrier, trackingNumber } = event.detail;
            console.log(`Carrier: ${carrier}, Tracking Number: ${trackingNumber}`);
            sessionStorage.setItem("Carrier", carrier)
            sessionStorage.setItem("Account Number", trackingNumber)
        });

    }
      
}

customElements.define('shipping-carrier', ShippingCarrier);